export const globalActionTypes = {
    SET_LOGGEDIN: 'SET_LOGGEDIN',
    SET_GLOBAL_AUTH_LOADING: 'SET_GLOBAL_AUTH_LOADING',
    SET_GLOBAL_CAROUSEL: 'SET_GLOBAL_CAROUSEL',
    SET_GLOBAL_RECENT_EVENTS: 'SET_GLOBAL_RECENT_EVENTS',
    SET_GLOBAL_LOADING: 'SET_GLOBAL_LOADING',
};

const globalReducer = (state, action) => {
    switch (action.type) {
        case globalActionTypes.SET_LOGGEDIN:
            return {
                ...state,
                loggedIn: action.loggedIn,
            };

        case globalActionTypes.SET_GLOBAL_AUTH_LOADING:
            return {
                ...state,
                globalAuthLoading: action.globalAuthLoading,
            };

        case globalActionTypes.SET_GLOBAL_LOADING:
            return {
                ...state,
                globalLoading: action.globalLoading,
            };

        case globalActionTypes.SET_GLOBAL_CAROUSEL:
            return {
                ...state,
                globalCarousel: action.globalCarousel,
            };

        case globalActionTypes.SET_GLOBAL_RECENT_EVENTS:
            return {
                ...state,
                globalRecentEvents: action.globalRecentEvents,
            };

        default:
            return state;
    }
};

export default globalReducer;